import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { SharedServiceRegistry } from './../../../shared-service-registry';
import { CoreServiceRegistry } from './../../../../core/core-service-registry';
import { ResourceService } from 'sce-core';
import { SearchService } from './../../../search/search.service';
import { SearchParams } from './../../../search/models/search-params.model';
import { SearchStatus } from './../../../search/models/search-status.model';
import { ViewBalancesCellRendererComponent } from './view-balances-cell-renderer/view-balances-cell-renderer.component';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { LotBalanceData } from '../../../models/lot-balance.model';
import { LotLocMovableUnitData } from '../../../models/lotlocmovableunit-data.model';
import { CommodityLocData } from '../../../models/commodityloc-data.model';
import { DataTableConfig } from '../../../search/models/data-table-config';
import { NEW_SEARCH_EVENT } from '../../../search/search-constants';
import { REFRESH_SEARCH_EVENT } from './../../../search/search-constants';
import { SearchEvent } from './../../../search/models/search-event';
import { Clause, Condition, SearchCriteria } from '../../../search/models/search-filter-model';

@Component({
  selector: 'lfwms-view-balances-popup',
  templateUrl: './view-balances-popup.component.html',
  styleUrls: ['./view-balances-popup.component.css']
})
export class ViewBalancesPopupComponent implements OnInit, OnDestroy {

  private http$: any;
  private searchParams: SearchParams;
  private searchStatus: SearchStatus;
  private searchCriteria: any;
  private searchCriteria1: any;
  private eventSubscription: Subscription;
  private defaultClauses: any;
  public isLoading: boolean = true;
  public searchService: SearchService;
  public resourceService: ResourceService;
  public showZeroBalances: boolean;
  public disableZeroBalanceToggle: boolean = false;
  public fieldsToCalculateTotal: any = [
  'qty', 'qtylocationLimit', 'qtylocationMinimum', 'qtyAllocated', 'qtyPicked', 'qtyExpected',
  'qtyPickInProcess', 'caseCnt', 'innerPack', 'pallet', 'cube', 'grossWgt', 'netWgt', 'otherUnit1',
  'otherUnit2', 'qtyPqtyExpectedicked'
  ]; // array of fields
  // Dynamic Inputs (set programatically, not via template)
  public balanceType: string = 'C';
  public storerKey: string;
  public sku: string;
  public lot: string;
  public tableId: any;
  public screenType: any;
  public primaryTableId: any = ' ';
  /* Dynamic Inputs (set via template , not programatically)
  * passed from parent component instead of assigning values
  * using modelRef from the parent component Refer - Pickmanagement Popup Component */
  @Input() inputConfig: any;

  constructor(coreServiceRegistry: CoreServiceRegistry,
      private sharedServiceRegistry: SharedServiceRegistry) {
    this.showZeroBalances = true;
    this.disableZeroBalanceToggle = false;
    this.http$ = coreServiceRegistry.http$;
    this.resourceService = coreServiceRegistry.resourceService;
  }

  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  public ngOnInit() {
    // if the inputConfig exist then assign a values to storerKey, sku, balanceType
    if (this.inputConfig) {
      this.storerKey = this.inputConfig.storerKey;
      this.sku = this.inputConfig.sku;
      this.balanceType = this.inputConfig.balanceType;
      this.lot = this.inputConfig.lot;
      this.tableId = this.inputConfig.tableId;
      // need's to call initialize method in ngOnInit when using inputConfig
      this.initialize();
    }
    this.eventSubscription = this.searchService.receiveEvent()
      .subscribe(($event: SearchEvent) => {
        if ($event.type === NEW_SEARCH_EVENT) {
          this.disableZeroBalanceToggle = false;
          const pinnedPayload: any = this.getPinnedPayLoad(this.balanceType);
          const enrichPayload: any = (data: any) => {
            if (this.balanceType === 'C') {
              pinnedPayload['qtylocationLimit']['cVal']
                = data['totalCapacityUnits'] ? +data['totalCapacityUnits'] : '0';
              pinnedPayload['qtylocationMinimum']['cVal']
                = data['totalCapacityMinimum'] ? +data['totalCapacityMinimum'] : '0';
              pinnedPayload['qty']['cVal']
                = data['totalQty'] ? +data['totalQty'] : '0';
              pinnedPayload['qtyAllocated']['cVal']
                = data['totalQtyAllocated'] ? +data['totalQtyAllocated'] : '0';
              pinnedPayload['qtyPicked']['cVal']
                = data['totalQtyPicked'] ? +data['totalQtyPicked'] : '0';
              pinnedPayload['qtyExpected']['cVal']
                = data['totalQtyExpected'] ? +data['totalQtyExpected'] : '0';
              pinnedPayload['qtyPickInProcess']['cVal']
                = data['totalQtyPickInProgress'] ? +data['totalQtyPickInProgress'] : '0';
            } else if (this.balanceType === 'L') {
              pinnedPayload['caseCnt']['cVal']
                = data['totalCaseCount'] ? +data['totalCaseCount'] : '0';
              pinnedPayload['cube']['cVal']
                = data['totalCube'] ? +data['totalCube'] : '0';
              pinnedPayload['grossWgt']['cVal']
                = data['totalGrossWeight'] ? +data['totalGrossWeight'] : '0';
              pinnedPayload['innerPack']['cVal']
                = data['totalInnerPack'] ? +data['totalInnerPack'] : '0';
              pinnedPayload['netWgt']['cVal']
                = data['totalNetWeight'] ? +data['totalNetWeight'] : '0';
              pinnedPayload['otherUnit1']['cVal']
                = data['totalOtherUnit1'] ? +data['totalOtherUnit1'] : '0';
              pinnedPayload['otherUnit2']['cVal']
                = data['totalOtherUnit2'] ? +data['totalOtherUnit2'] : '0';
              pinnedPayload['pallet']['cVal']
                = data['totalPallet'] ? +data['totalPallet'] : '0';
              pinnedPayload['qty']['cVal']
                = data['totalQty'] ? +data['totalQty'] : '0';
              pinnedPayload['qtyAllocated']['cVal']
                = data['totalQtyAllocated'] ? +data['totalQtyAllocated'] : '0';
              pinnedPayload['qtyPreAllocated']['cVal']
                = data['totalQtyPreAllocated'] ? +data['totalQtyPreAllocated'] : '0';
            } else {
              pinnedPayload['qty']['cVal']
                = data['totalQty'] ? +data['totalQty'] : '0';
              pinnedPayload['qtyAllocated']['cVal']
                = data['totalQtyAllocated'] ? +data['totalQtyAllocated'] : '0';
              pinnedPayload['qtyPicked']['cVal']
                = data['totalQtyPicked'] ? +data['totalQtyPicked'] : '0';
              pinnedPayload['qtyExpected']['cVal']
                = data['totalQtyExpected'] ? +data['totalQtyExpected'] : '0';
              pinnedPayload['qtyPickInProcess']['cVal']
                = data['totalQtyPickInProgress'] ? +data['totalQtyPickInProgress'] : '0';
            }
          };
          // LFWM-3191- assigining screenType to outbound xdock and inbound xdock.
          if (this.primaryTableId === 'ixdocktd') {
            this.screenType = 'xdockd';
          } else if (this.primaryTableId === 'oxdocktd') {
            this.screenType = 'oxdockd';
          } else {
            this.screenType = ' ';
          }
          if (this.balanceType === 'C') {
            this.getAllCommodityLocData()
              .subscribe((responseData: CommodityLocData) => {
                enrichPayload(responseData);
                this.searchService.getPagedData().pinnedPageRows = [pinnedPayload];
                this.searchService.publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
              });
          } else if (this.balanceType === 'L') {
            this.getAllLotBalance()
              .subscribe((responseData: LotBalanceData) => {
                enrichPayload(responseData);
                this.searchService.getPagedData().pinnedPageRows = [pinnedPayload];
                this.searchService.publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
              });
          } else {
            this.getAllLotLocMUBalance()
              .subscribe((responseData: LotLocMovableUnitData) => {
                enrichPayload(responseData);
                this.searchService.getPagedData().pinnedPageRows = [pinnedPayload];
                this.searchService.publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
              });
          }
        }
      });
  }

  private getPinnedPayLoad(balanceType) {
    const pinnedPayload: any = {};
    this.searchService.getMetadata().columnList.forEach((column: any) => {
      if (this.fieldsToCalculateTotal.includes(column.propertyName)) {
        pinnedPayload[column.propertyName] = { 'cName': column.propertyName, cVal: 0 };
      } else {
        pinnedPayload[column.propertyName] = { 'cName': column.propertyName, cVal: '' };
      }
    });
    pinnedPayload['isSelected'] = false;
    return pinnedPayload;
  }

  public initialize() {
    this.searchParams = new SearchParams();
    this.searchParams.dataTableConfig = new DataTableConfig();
    this.searchStatus = new SearchStatus();
    const pinnedColumnStart = this.balanceType === 'C' ? 'locationType' : 'lot';
    this.searchParams.dataTableConfig.columnPinnedRendererMapping[pinnedColumnStart]
      = ViewBalancesCellRendererComponent;
    if (this.balanceType === 'C') {
      this.searchParams.tableId = 'locbaltd';
      this.searchParams.isFullFetch = true;
    } else if (this.balanceType === 'L') {
      this.searchParams.tableId = 'lotbaltd';
    } else if (this.balanceType === 'M') {
      this.searchParams.tableId = 'movbaltd';
      this.searchParams.isFullFetch = true;
    }
    this.searchService = this.sharedServiceRegistry
      .createSearchService(this.searchParams, this.searchStatus);
        this.searchCriteria = this.createSearchCriteria(); 
    this.searchService.setSearchCriteria(this.searchCriteria);
    this.searchService.fetchMetadata()
      .subscribe(() => {
        this.isLoading = false;
        this.toggleZeroBalances();
      });
  }


  public createSearchCriteria()
    {
      const defaultSearchCriteria = new SearchCriteria();
      defaultSearchCriteria.conditions = [];
      const defaultCondition = this.createDefaultSearchCondition(1);
      defaultCondition.operator = 'AND';
      const defaultClause1 = new Clause();
      defaultClause1.operation = '=';
      defaultClause1.column = 'storerKey';
      defaultClause1.value = this.storerKey;
      defaultClause1.logicalOperation = null;
      const defaultClause2 = new Clause();
      defaultClause2.operation = '=';
      defaultClause2.column = 'sku';
      defaultClause2.value = this.sku;
      defaultClause2.logicalOperation = 'AND';
      //lfwm-2335 added lot filter
      if(this.lot){
        const defaultClause3 = new Clause();
        defaultClause3.operation = '=';
        defaultClause3.column = 'lot';
        defaultClause3.value = this.lot;
        defaultClause3.logicalOperation = 'AND';
        defaultCondition.clauses = [defaultClause1, defaultClause2,defaultClause3];
      } else{
        defaultCondition.clauses = [defaultClause1, defaultClause2];
      }
     defaultSearchCriteria.conditions.push(defaultCondition);
    return defaultSearchCriteria;
    }
  public toggleZeroBalances(skipToggle?: boolean) {
    this.disableZeroBalanceToggle = true;
     /*if (skipToggle) {
      this.show//*ZeroBalances = true;
    } else {
      this.showZeroBalances = !this.showZeroBalances;
    }*/
    if (!this.showZeroBalances) {
      this.searchCriteria1 = new SearchCriteria();
      this.searchCriteria1 = this.createSearchCriteria();
   
      const defaultCondition = this.createDefaultSearchCondition(1);
      const defaultClause1 = new Clause();
      defaultClause1.operation = '>';
      defaultClause1.column = 'qty';
      defaultClause1.value = 0;
      defaultClause1.logicalOperation = 'AND';
      const defaultClause2 = new Clause();
      if ((this.balanceType !== 'L')) {
      defaultClause2.operation = '>';
      defaultClause2.column = 'qtyExpected';
      defaultClause2.value = 0;
      defaultClause2.logicalOperation = 'OR';
      }
      defaultCondition.clauses = [defaultClause1, defaultClause2];
      this.searchCriteria1.conditions.push(defaultCondition);
      this.searchService.setSearchCriteria(this.searchCriteria1);
      this.searchService.performSearch();
    } else {
    this.searchService.setSearchCriteria(this.searchCriteria);
    this.searchService.performSearch();
    }
  }

  public getAllCommodityLocData(): Observable<CommodityLocData> {
    const response$: any = this.http$
      .get(`api/asn/`+ this.tableId + `/` + this.screenType + `/` + this.storerKey + `/` + this.sku + `/loc/balance`)
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
              return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

  public getAllLotBalance(): Observable<LotBalanceData> {
    const response$: any = this.http$
      .get(`api/asn/`+ this.tableId + `/` + this.screenType + `/` + this.storerKey  + `/` + this.sku + `/lot/balance`)
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

  public getAllLotLocMUBalance(): Observable<LotLocMovableUnitData> {
    let url = '';
    if(this.lot){
     url = `api/asn/`+ this.tableId + `/` + this.screenType + `/` + this.storerKey + `/` + this.sku +  `/` + this.lot +`/LotLocMovable/balance`
    } else {
      url = `api/asn/`+ this.tableId + `/` + this.screenType + `/` + this.storerKey + `/` + this.sku +  `/` + ' ' +`/LotLocMovable/balance`
    }
    const response$: any = this.http$
      .get(url)
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0) {
            if (error.error.statusCode !== 200) {
                return Observable.throw(error.error.statusMessage);
            }
        }
      });
    return response$;
  }

  public ngOnDestroy() {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
    // Memory cleanup
    this.searchService = null;
    this.showZeroBalances = true;
  }
  protected createDefaultSearchCondition(id) {
    const defaultCondition = new Condition();
    defaultCondition.id = id;
    defaultCondition.displayMode = 'VIEW';
    return defaultCondition;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/common/view-balances-popup/view-balances-popup.component.ts